// src/config/api.ts
export const API_BASE = '/api';